// extracted by mini-css-extract-plugin
export var wrapper = "ArticleNumberedHeading-module--wrapper--XbYuh";
export var wrapperFull = "ArticleNumberedHeading-module--wrapperFull--5cwsm";
export var bgNumber = "ArticleNumberedHeading-module--bgNumber--qnzpF";
export var titleWrapper = "ArticleNumberedHeading-module--titleWrapper--2hWyz";
export var numberCircle = "ArticleNumberedHeading-module--numberCircle--1BtVi";
export var numberText = "ArticleNumberedHeading-module--numberText--9pXkh";
export var numberTextSmaller = "ArticleNumberedHeading-module--numberTextSmaller--2cuUi";
export var title = "ArticleNumberedHeading-module--title--eb-ds";
export var description = "ArticleNumberedHeading-module--description--3mcWE";
export var award = "ArticleNumberedHeading-module--award--1mjvH";
export var dotSeparator = "ArticleNumberedHeading-module--dotSeparator--GEJ2a";